module.exports = __webpack_public_path__ + "img/monitorbox00.7e27a5a6.jpg";